import { motion } from "framer-motion";
import { GraduationCap, Sparkles } from "lucide-react";

const CREDENTIALS = [
  {
    icon: GraduationCap,
    color: "#FFB800",
    tag: "Postgraduate · Design",
    title: "Master in Design & Critical Thinking",
    school: "Chandigarh University",
    body: "Developed a strong foundation in design research, visual communication, storytelling and critical thinking—skills that continue to shape how I approach brands, campaigns and creative leadership.",
    id: "masters",
  },
  {
    icon: Sparkles,
    color: "#00E699",
    tag: "Certification · AI × Product",
    title: "AI-Powered Product Design",
    school: "Professional Certification",
    body: "Training in AI-assisted product thinking, prompt-led workflows, rapid visual exploration and human–AI collaboration.",
    id: "ai-cert",
  },
];

export default function Education() {
  return (
    <section id="education" data-testid="education-section" className="py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <p className="font-mono2 text-xs tracking-[0.3em] uppercase text-[#FF4D23] mb-3">01 · Education</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight uppercase" data-testid="education-heading">
              Education &amp; <span className="text-[#FF4D23]">Continuous Learning</span>
            </h2>
          </div>
          <p className="text-sm text-[#B6BDCB] max-w-sm">
            A foundation in design thinking, visual communication and emerging AI workflows—continuously applied to real brand and business challenges.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {CREDENTIALS.map((c, i) => (
            <motion.div
              key={c.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              whileHover={{ y: -4 }}
              className="relative bg-[#12141B] border border-[#222634] rounded-2xl p-7 sm:p-9 overflow-hidden hover:border-[#3B4254] transition-colors"
              data-testid={`education-card-${c.id}`}
            >
              <div
                className="absolute -top-16 -right-16 w-48 h-48 rounded-full opacity-10 blur-[80px] pointer-events-none"
                style={{ background: c.color }}
              />
              <div className="flex items-start justify-between gap-4">
                <span className="w-12 h-12 rounded-xl border flex items-center justify-center" style={{ borderColor: `${c.color}55`, background: `${c.color}14` }}>
                  <c.icon size={22} style={{ color: c.color }} />
                </span>
                <span className="text-[10px] font-mono2 tracking-[0.25em] uppercase text-[#8A92A3] border border-[#3B4254] rounded-full px-3 py-1.5">
                  {c.tag}
                </span>
              </div>
              <h3 className="font-display font-bold text-xl sm:text-2xl mt-6">{c.title}</h3>
              <p className="font-mono2 text-xs tracking-widest uppercase mt-2" style={{ color: c.color }}>
                {c.school}
              </p>
              <p className="text-sm sm:text-base leading-relaxed text-[#B6BDCB] mt-4">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
